var geekRunner = function() {
    initGeekSlick();
}

var initGeekSlick = function() {
    $('.geek-if-slick').each(
        function() {
            var that = $(this);
            that.find('.geek-block__arrow--prev').on('click', function() {
                that.slick('slickPrev');
            });

            that.find('.geek-block__arrow--next').on('click', function() {
                that.slick('slickNext');
            });

            that.slick({
                dots: true,
                infinite: true,
                speed: 500,
                fade: true,
                cssEase: 'linear',
                prevArrow: false,
                nextArrow: false
            });
        }
    );

    $('.geek-slick').each(
        function() {
            var that = $(this);
            that.find('.geek-block__arrow--prev').on('click', function() {
                that.slick('slickPrev');
            });

            that.find('.geek-block__arrow--next').on('click', function() {
                that.slick('slickNext');
            });

            that.slick({
                dots: true,
                infinite: true,
                speed: 500,
                fade: true,
                cssEase: 'linear',
                prevArrow: false,
                nextArrow: false
            });
        }
    );
}

$(function() {
    geekRunner();
});
